import React, { useEffect } from 'react';
import { IPluMenuState } from '../../common/interfaces/states/IPluMenuState';
import { AppState } from '../../common/redux/configure-store';
import { connect } from 'react-redux';
import ProductDisplayLayout from './product-display-layout';

import { ConsumableGroup } from '../../common/interfaces/dtos/ConsumableGroup';
import { ProductDisplayView } from '../../common/enumerations/product-display-view';
import { createProductDisplayMenu } from '../../common/helpers/create-product-display-menu';
import { ISelectedItem } from '../../common/interfaces/dtos/ISelectedItem';
import { POSModeState } from 'src/common/interfaces/states/POSModeState';

type Props = IProductDisplayLayoutWrapperProps & IProductDisplayLayoutWrapperState;

const ProductDisplayLayoutWrapper: React.FC<Props> = (props): JSX.Element => {
  function createDisplayMenu(menuData: ConsumableGroup): void {
    createProductDisplayMenu(menuData);
  }

  useEffect((): void => {
    createDisplayMenu(props.pluMenuState.consumableGroup);
  }, [props.pluMenuState.consumableGroup]);

  return (
    <ProductDisplayLayout
      productDisplayMenuData={props.pluMenuState.productDisplayMenus}
      onProductSelected={props.onProductSelected}
      onFinish={props.onFinish}
      onKeypadSubmit={props.onKeypadSubmit}
      pluTabValue={props.pluTabValue}
      posModeState={props.posModeState}
    />
  );
};

interface IProductDisplayLayoutWrapperProps {
  displayView: ProductDisplayView;
  displaySize: number;
  onProductSelected: (selectedItem: ISelectedItem) => Promise<void>;
  onFinish: () => void;
  onKeypadSubmit: (input: string) => Promise<void>;
  pluTabValue: number;
  posModeState: POSModeState;
}

interface IProductDisplayLayoutWrapperState {
  pluMenuState: IPluMenuState;
  posModeState: POSModeState;
}

const mapStateToProps = (state: AppState): IProductDisplayLayoutWrapperState => ({
  pluMenuState: state.pluMenu,
  posModeState: state.posMode,
});

export default connect(mapStateToProps)(ProductDisplayLayoutWrapper);
